import React, { lazy, Suspense } from "react";
import { ODSIconProps } from "./ODSIcon.types";
import "@/css/icons/ODSIcon.css";

const ODSAdd = lazy(() => import("./add/ODSAdd"));
const ODSAddCard = lazy(() => import("./add-card/ODSAddCard"));
const ODSArrange = lazy(() => import("./arrange/ODSArrange"));
const ODSArrowDown = lazy(() => import("./arrow-down/ODSArrowDown"));
const ODSArrowLeft = lazy(() => import("./arrow-left/ODSArrowLeft"));
const ODSArrowRight = lazy(() => import("./arrow-right/ODSArrowRight"));
const ODSArrowUTurnBackwards = lazy(
  () => import("./arrow-u-turn-backwards/ODSArrowUTurnBackwards")
);
const ODSArrowUTurnForwards = lazy(
  () => import("./arrow-u-turn-forwards/ODSArrowUTurnForwards")
);
const ODSArrowUp = lazy(() => import("./arrow-up/ODSArrowUp"));
const ODSAutoLogin = lazy(() => import("./auto-login/ODSAutoLogin"));
const ODSBackspace = lazy(() => import("./backspace/ODSBackspace"));
const ODSBackward = lazy(() => import("./backward/ODSBackward"));
const ODSCast = lazy(() => import("./cast/ODSCast"));
const ODSChangelog = lazy(() => import("./changelog/ODSChangelog"));
const ODSCheckmark = lazy(() => import("./checkmark/ODSCheckmark"));
const ODSCircleAdd = lazy(() => import("./circle-add/ODSCircleAdd"));
const ODSCircleClose = lazy(() => import("./circle-close/ODSCircleClose"));
const ODSCircleFastForward = lazy(
  () => import("./circle-fast-forward/ODSCircleFastForward")
);
const ODSCircleMinus = lazy(() => import("./circle-minus/ODSCircleMinus"));
const ODSCirclePause = lazy(() => import("./circle-pause/ODSCirclePause"));
const ODSCirclePlay = lazy(() => import("./circle-play/ODSCirclePlay"));
const ODSClose = lazy(() => import("./close/ODSClose"));
const ODSCompare = lazy(() => import("./compare/ODSCompare"));
const ODSCopyPaste = lazy(() => import("./copy-paste/ODSCopyPaste"));
const ODSCutPaste = lazy(() => import("./cut-paste/ODSCutPaste"));
const ODSDelete = lazy(() => import("./delete/ODSDelete"));
const ODSDisabledMicrophone = lazy(
  () => import("./disabled-microphone/ODSDisabledMicrophone")
);
const ODSDotGrid = lazy(() => import("./dot-grid/ODSDotGrid"));
const ODSDownload = lazy(() => import("./download/ODSDownload"));
const ODSDownloadFromCloud = lazy(
  () => import("./download-from-cloud/ODSDownloadFromCloud")
);
const ODSDragAndDrop = lazy(() => import("./drag-and-drop/ODSDragAndDrop"));
const ODSEdit = lazy(() => import("./edit/ODSEdit"));
const ODSExport = lazy(() => import("./export/ODSExport"));
const ODSFastForward = lazy(() => import("./fast-forward/ODSFastForward"));
const ODSFilter = lazy(() => import("./filter/ODSFilter"));
const ODSFilter2 = lazy(() => import("./filter-2/ODSFilter2"));
const ODSForward = lazy(() => import("./forward/ODSForward"));
const ODSGroup = lazy(() => import("./group/ODSGroup"));
const ODSImport = lazy(() => import("./import/ODSImport"));
const ODSInstall = lazy(() => import("./install/ODSInstall"));
const ODSLaunch = lazy(() => import("./launch/ODSLaunch"));
const ODSLightDarkMode = lazy(
  () => import("./light-dark-mode/ODSLightDarkMode")
);
const ODSLink = lazy(() => import("./link/ODSLink"));
const ODSLogout = lazy(() => import("./logout/ODSLogout"));
const ODSLoop = lazy(() => import("./loop/ODSLoop"));
const ODSMagicWand = lazy(() => import("./magic-wand/ODSMagicWand"));
const ODSMaximizeScreen = lazy(
  () => import("./maximize-screen/ODSMaximizeScreen")
);
const ODSMenu = lazy(() => import("./menu/ODSMenu"));
const ODSMicrophone = lazy(() => import("./microphone/ODSMicrophone"));
const ODSMinimizeScreen = lazy(
  () => import("./minimize-screen/ODSMinimizeScreen")
);
const ODSMinus = lazy(() => import("./minus/ODSMinus"));
const ODSMore = lazy(() => import("./more/ODSMore"));
const ODSMove = lazy(() => import("./move/ODSMove"));
const ODSMute = lazy(() => import("./mute/ODSMute"));
const ODSNotification = lazy(() => import("./notification/ODSNotification"));
const ODSPause = lazy(() => import("./pause/ODSPause"));
const ODSPin = lazy(() => import("./pin/ODSPin"));
const ODSPlay = lazy(() => import("./play/ODSPlay"));
const ODSPopUpWindow = lazy(() => import("./pop-up-window/ODSPopUpWindow"));
const ODSPower = lazy(() => import("./power/ODSPower"));
const ODSPrevious = lazy(() => import("./previous/ODSPrevious"));
const ODSPrint = lazy(() => import("./print/ODSPrint"));
const ODSPublish = lazy(() => import("./publish/ODSPublish"));
const ODSRecord = lazy(() => import("./record/ODSRecord"));
const ODSRefresh = lazy(() => import("./refresh/ODSRefresh"));
const ODSReplyAll = lazy(() => import("./reply-all/ODSReplyAll"));
const ODSReplyForward = lazy(() => import("./reply-forward/ODSReplyForward"));
const ODSRestart = lazy(() => import("./restart/ODSRestart"));
const ODSReturn = lazy(() => import("./return/ODSReturn"));
const ODSSearch = lazy(() => import("./search/ODSSearch"));
const ODSShare = lazy(() => import("./share/ODSShare"));
const ODSShoppingCart = lazy(() => import("./shopping-cart/ODSShoppingCart"));
const ODSShuffle = lazy(() => import("./shuffle/ODSShuffle"));
const ODSSort = lazy(() => import("./sort/ODSSort"));
const ODSSoundOn = lazy(() => import("./sound-on/ODSSoundOn"));
const ODSStar = lazy(() => import("./star/ODSStar"));
const ODSSuccess = lazy(() => import("./success/ODSSuccess"));
const ODSThumbsDown = lazy(() => import("./thumbs-down/ODSThumbsDown"));
const ODSThumbsUp = lazy(() => import("./thumbs-up/ODSThumbsUp"));
const ODSTilesAdd = lazy(() => import("./tiles-add/ODSTilesAdd"));
const ODSUngroup = lazy(() => import("./ungroup/ODSUngroup"));
const ODSUpload = lazy(() => import("./upload/ODSUpload"));
const ODSUploadToCloud = lazy(
  () => import("./upload-to-cloud/ODSUploadToCloud")
);
const ODSVisibilityOff = lazy(
  () => import("./visibility-off/ODSVisibilityOff")
);
const ODSVisibilityOn = lazy(() => import("./visibility-on/ODSVisibilityOn"));
const ODSVolumeDown = lazy(() => import("./volume-down/ODSVolumeDown"));
const ODSVolumeUp = lazy(() => import("./volume-up/ODSVolumeUp"));
const ODSZoomIn = lazy(() => import("./zoom-in/ODSZoomIn"));
const ODSZoomOut = lazy(() => import("./zoom-out/ODSZoomOut"));
const ODSAntivirusProtection = lazy(
  () => import("./antivirus-protection/ODSAntivirusProtection")
);
const ODSCompliance = lazy(() => import("./compliance/ODSCompliance"));
const ODSCyberSecurity = lazy(
  () => import("./cyber-security/ODSCyberSecurity")
);
const ODSError = lazy(() => import("./error/ODSError"));
const ODSHelp = lazy(() => import("./help/ODSHelp"));
const ODSHighPriority = lazy(() => import("./high-priority/ODSHighPriority"));
const ODSImprintDataprivacy = lazy(
  () => import("./imprint-dataprivacy/ODSImprintDataprivacy")
);
const ODSInformation = lazy(() => import("./information/ODSInformation"));
const ODSLegal = lazy(() => import("./legal/ODSLegal"));
const ODSNetworkDisrupted = lazy(
  () => import("./network-disrupted/ODSNetworkDisrupted")
);
const ODSPasswordBreaking = lazy(
  () => import("./password-breaking/ODSPasswordBreaking")
);
const ODSSecurity = lazy(() => import("./security/ODSSecurity"));
const ODSTrafficDisruption = lazy(
  () => import("./traffic-disruption/ODSTrafficDisruption")
);
const ODSUnknown = lazy(() => import("./unknown/ODSUnknown"));
const ODSWarning = lazy(() => import("./warning/ODSWarning"));
const ODSAddPhone = lazy(() => import("./add-phone/ODSAddPhone"));
const ODSBlog = lazy(() => import("./blog/ODSBlog"));
const ODSCall = lazy(() => import("./call/ODSCall"));
const ODSCallIncoming = lazy(() => import("./call-incoming/ODSCallIncoming"));
const ODSCallOutgoing = lazy(() => import("./call-outgoing/ODSCallOutgoing"));
const ODSChat = lazy(() => import("./chat/ODSChat"));
const ODSChatBadge = lazy(() => import("./chat-badge/ODSChatBadge"));
const ODSChatText = lazy(() => import("./chat-text/ODSChatText"));
const ODSEmail = lazy(() => import("./email/ODSEmail"));
const ODSEndCall = lazy(() => import("./end-call/ODSEndCall"));
const ODSFeedback = lazy(() => import("./feedback/ODSFeedback"));
const ODSFlightMode = lazy(() => import("./flight-mode/ODSFlightMode"));
const ODSHappyPerson = lazy(() => import("./happy-person/ODSHappyPerson"));
const ODSInbox = lazy(() => import("./inbox/ODSInbox"));
const ODSLoyaltyEarned = lazy(
  () => import("./loyalty-earned/ODSLoyaltyEarned")
);
const ODSLoyaltyLost = lazy(() => import("./loyalty-lost/ODSLoyaltyLost"));
const ODSMailOpened = lazy(() => import("./mail-opened/ODSMailOpened"));
const ODSMessage = lazy(() => import("./message/ODSMessage"));
const ODSMessageIncoming = lazy(
  () => import("./message-incoming/ODSMessageIncoming")
);
const ODSMessageOutgoing = lazy(
  () => import("./message-outgoing/ODSMessageOutgoing")
);
const ODSMms = lazy(() => import("./mms/ODSMms"));
const ODSMobilePhoneNumber = lazy(
  () => import("./mobile-phone-number/ODSMobilePhoneNumber")
);
const ODSMobileSignal = lazy(() => import("./mobile-signal/ODSMobileSignal"));
const ODSNewEmail = lazy(() => import("./new-email/ODSNewEmail"));
const ODSOutbox = lazy(() => import("./outbox/ODSOutbox"));
const ODSRecipient = lazy(() => import("./recipient/ODSRecipient"));
const ODSSaveEmailsToDrafts = lazy(
  () => import("./save-emails-to-drafts/ODSSaveEmailsToDrafts")
);
const ODSSms = lazy(() => import("./sms/ODSSms"));
const ODSSpam = lazy(() => import("./spam/ODSSpam"));
const ODSVoiceMessages = lazy(
  () => import("./voice-messages/ODSVoiceMessages")
);
const ODSAchievement = lazy(() => import("./achievement/ODSAchievement"));
const ODSAndroid = lazy(() => import("./android/ODSAndroid"));
const ODSApi = lazy(() => import("./api/ODSApi"));
const ODSApple = lazy(() => import("./apple/ODSApple"));
const ODSApplications = lazy(() => import("./applications/ODSApplications"));
const ODSAt = lazy(() => import("./at/ODSAt"));
const ODSAvailableKeychain = lazy(
  () => import("./available-keychain/ODSAvailableKeychain")
);
const ODSBank = lazy(() => import("./bank/ODSBank"));
const ODSBattery = lazy(() => import("./battery/ODSBattery"));
const ODSBatteryChargeOptimize = lazy(
  () => import("./battery-charge-optimize/ODSBatteryChargeOptimize")
);
const ODSBiometric = lazy(() => import("./biometric/ODSBiometric"));
const ODSBirthday = lazy(() => import("./birthday/ODSBirthday"));
const ODSBookmark = lazy(() => import("./bookmark/ODSBookmark"));
const ODSCalendar = lazy(() => import("./calendar/ODSCalendar"));
const ODSClipboard = lazy(() => import("./clipboard/ODSClipboard"));
const ODSClock = lazy(() => import("./clock/ODSClock"));
const ODSCloud = lazy(() => import("./cloud/ODSCloud"));
const ODSCloudSecurity = lazy(
  () => import("./cloud-security/ODSCloudSecurity")
);
const ODSCodeScanner = lazy(() => import("./code-scanner/ODSCodeScanner"));
const ODSColorSelection = lazy(
  () => import("./color-selection/ODSColorSelection")
);
const ODSCompany = lazy(() => import("./company/ODSCompany"));
const ODSCountry = lazy(() => import("./country/ODSCountry"));
const ODSCpu = lazy(() => import("./cpu/ODSCpu"));
const ODSCreditCard = lazy(() => import("./credit-card/ODSCreditCard"));
const ODSDataVisualisation = lazy(
  () => import("./data-visualisation/ODSDataVisualisation")
);
const ODSDigitalBanking = lazy(
  () => import("./digital-banking/ODSDigitalBanking")
);
const ODSDigitalMedia = lazy(() => import("./digital-media/ODSDigitalMedia"));
const ODSDiscount = lazy(() => import("./discount/ODSDiscount"));
const ODSDiscount3 = lazy(() => import("./discount-3/ODSDiscount3"));
const ODSESim = lazy(() => import("./e-sim/ODSESim"));
const ODSEu = lazy(() => import("./eu/ODSEu"));
const ODSFaceMask = lazy(() => import("./face-mask/ODSFaceMask"));
const ODSFeatures = lazy(() => import("./features/ODSFeatures"));
const ODSFlexibleTariffs = lazy(
  () => import("./flexible-tariffs/ODSFlexibleTariffs")
);
const ODSFolder = lazy(() => import("./folder/ODSFolder"));
const ODSFood = lazy(() => import("./food/ODSFood"));
const ODSGenderDiverse = lazy(
  () => import("./gender-diverse/ODSGenderDiverse")
);
const ODSGenderFemale = lazy(() => import("./gender-female/ODSGenderFemale"));
const ODSGenderMale = lazy(() => import("./gender-male/ODSGenderMale"));
const ODSGenderNeutral = lazy(
  () => import("./gender-neutral/ODSGenderNeutral")
);
const ODSHalfRating = lazy(() => import("./half-rating/ODSHalfRating"));
const ODSHeart = lazy(() => import("./heart/ODSHeart"));
const ODSHeight = lazy(() => import("./height/ODSHeight"));
const ODSHistory = lazy(() => import("./history/ODSHistory"));
const ODSHourGlass = lazy(() => import("./hour-glass/ODSHourGlass"));
const ODSId = lazy(() => import("./id/ODSId"));
const ODSInStock = lazy(() => import("./in-stock/ODSInStock"));
const ODSInternational = lazy(() => import("./international/ODSInternational"));
const ODSInternationalSms = lazy(
  () => import("./international-sms/ODSInternationalSms")
);
const ODSKey = lazy(() => import("./key/ODSKey"));
const ODSLanguage = lazy(() => import("./language/ODSLanguage"));
const ODSLightbulb = lazy(() => import("./lightbulb/ODSLightbulb"));
const ODSLock = lazy(() => import("./lock/ODSLock"));
const ODSLoyalty = lazy(() => import("./loyalty/ODSLoyalty"));
const ODSMediaFolder = lazy(() => import("./media-folder/ODSMediaFolder"));
const ODSMicrophoneExternal = lazy(
  () => import("./microphone-external/ODSMicrophoneExternal")
);
const ODSMultiSim = lazy(() => import("./multi-sim/ODSMultiSim"));
const ODSMusic = lazy(() => import("./music/ODSMusic"));
const ODSNews = lazy(() => import("./news/ODSNews"));
const ODSOutOfStock = lazy(() => import("./out-of-stock/ODSOutOfStock"));
const ODSPackage = lazy(() => import("./package/ODSPackage"));
const ODSPackageDelivery = lazy(
  () => import("./package-delivery/ODSPackageDelivery")
);
const ODSPersonWalking = lazy(
  () => import("./person-walking/ODSPersonWalking")
);
const ODSPrepaidActivate = lazy(
  () => import("./prepaid-activate/ODSPrepaidActivate")
);
const ODSPriceTag = lazy(() => import("./price-tag/ODSPriceTag"));
const ODSRoute = lazy(() => import("./route/ODSRoute"));
const ODSRss = lazy(() => import("./rss/ODSRss"));
const ODSSale = lazy(() => import("./sale/ODSSale"));
const ODSShop = lazy(() => import("./shop/ODSShop"));
const ODSSignal = lazy(() => import("./signal/ODSSignal"));
const ODSSimCard = lazy(() => import("./sim-card/ODSSimCard"));
const ODSSimInactive = lazy(() => import("./sim-inactive/ODSSimInactive"));
const ODSSmile = lazy(() => import("./smile/ODSSmile"));
const ODSSortIndicatorDown = lazy(
  () => import("./sort-indicator-down/ODSSortIndicatorDown")
);
const ODSSortIndicatorUp = lazy(
  () => import("./sort-indicator-up/ODSSortIndicatorUp")
);
const ODSStatusInactive = lazy(
  () => import("./status-inactive/ODSStatusInactive")
);
const ODSStopwatch = lazy(() => import("./stopwatch/ODSStopwatch"));
const ODSSupportChat = lazy(() => import("./support-chat/ODSSupportChat"));
const ODSSustainable = lazy(() => import("./sustainable/ODSSustainable"));
const ODSTariffs = lazy(() => import("./tariffs/ODSTariffs"));
const ODSTemperature = lazy(() => import("./temperature/ODSTemperature"));
const ODSThreats = lazy(() => import("./threats/ODSThreats"));
const ODSToDoList = lazy(() => import("./to-do-list/ODSToDoList"));
const ODSTools = lazy(() => import("./tools/ODSTools"));
const ODSTransport = lazy(() => import("./transport/ODSTransport"));
const ODSTwoFactorAuthentification = lazy(
  () => import("./two-factor-authentification/ODSTwoFactorAuthentification")
);
const ODSUnlock = lazy(() => import("./unlock/ODSUnlock"));
const ODSVoucher = lazy(() => import("./voucher/ODSVoucher"));
const ODSWaiting = lazy(() => import("./waiting/ODSWaiting"));
const ODSWallet = lazy(() => import("./wallet/ODSWallet"));
const ODSAddDevice = lazy(() => import("./add-device/ODSAddDevice"));
const ODSCameraOff = lazy(() => import("./camera-off/ODSCameraOff"));
const ODSChangeCamera = lazy(() => import("./change-camera/ODSChangeCamera"));
const ODSComputer = lazy(() => import("./computer/ODSComputer"));
const ODSControllerDevice = lazy(
  () => import("./controller-device/ODSControllerDevice")
);
const ODSDeviceEthernet = lazy(
  () => import("./device-ethernet/ODSDeviceEthernet")
);
const ODSDeviceTv = lazy(() => import("./device-tv/ODSDeviceTv"));
const ODSDongle = lazy(() => import("./dongle/ODSDongle"));
const ODSFax = lazy(() => import("./fax/ODSFax"));
const ODSFixedLineServices = lazy(
  () => import("./fixed-line-services/ODSFixedLineServices")
);
const ODSFixedLineServices3 = lazy(
  () => import("./fixed-line-services-3/ODSFixedLineServices3")
);
const ODSGameController = lazy(
  () => import("./game-controller/ODSGameController")
);
const ODSMediaReceiver = lazy(
  () => import("./media-receiver/ODSMediaReceiver")
);
const ODSMeshWifi = lazy(() => import("./mesh-wifi/ODSMeshWifi"));
const ODSMobileData = lazy(() => import("./mobile-data/ODSMobileData"));
const ODSMobileDevices = lazy(
  () => import("./mobile-devices/ODSMobileDevices")
);
const ODSMobileEquipment = lazy(
  () => import("./mobile-equipment/ODSMobileEquipment")
);
const ODSMobilePhoneInsurance = lazy(
  () => import("./mobile-phone-insurance/ODSMobilePhoneInsurance")
);
const ODSMobileServices = lazy(
  () => import("./mobile-services/ODSMobileServices")
);
const ODSPhone = lazy(() => import("./phone/ODSPhone"));
const ODSPhoneWithMobilePlan = lazy(
  () => import("./phone-with-mobile-plan/ODSPhoneWithMobilePlan")
);
const ODSPhoneWithoutMobilePlan = lazy(
  () => import("./phone-without-mobile-plan/ODSPhoneWithoutMobilePlan")
);
const ODSPhotoCamera = lazy(() => import("./photo-camera/ODSPhotoCamera"));
const ODSRemoteController = lazy(
  () => import("./remote-controller/ODSRemoteController")
);
const ODSReplacementMobilePhone = lazy(
  () => import("./replacement-mobile-phone/ODSReplacementMobilePhone")
);
const ODSRotateLocked = lazy(() => import("./rotate-locked/ODSRotateLocked"));
const ODSRotateOpen = lazy(() => import("./rotate-open/ODSRotateOpen"));
const ODSRouter = lazy(() => import("./router/ODSRouter"));
const ODSScreenRotate = lazy(() => import("./screen-rotate/ODSScreenRotate"));
const ODSServer = lazy(() => import("./server/ODSServer"));
const ODSSmartSpeaker = lazy(() => import("./smart-speaker/ODSSmartSpeaker"));
const ODSTablet = lazy(() => import("./tablet/ODSTablet"));
const ODSTvAndMobile = lazy(() => import("./tv-and-mobile/ODSTvAndMobile"));
const ODSVideoCamera = lazy(() => import("./video-camera/ODSVideoCamera"));
const ODSWatch = lazy(() => import("./watch/ODSWatch"));
const ODSWifiDevice = lazy(() => import("./wifi-device/ODSWifiDevice"));
const ODSHome = lazy(() => import("./home/ODSHome"));
const ODSInternetHome = lazy(() => import("./internet-home/ODSInternetHome"));
const ODSIot = lazy(() => import("./iot/ODSIot"));
const ODSLightBulb = lazy(() => import("./light-bulb/ODSLightBulb"));
const ODSNetworkSecure = lazy(
  () => import("./network-secure/ODSNetworkSecure")
);
const ODSPowerSocket = lazy(() => import("./power-socket/ODSPowerSocket"));
const ODSPowerSocket3 = lazy(() => import("./power-socket-3/ODSPowerSocket3"));
const ODSRouterDisconnected = lazy(
  () => import("./router-disconnected/ODSRouterDisconnected")
);
const ODSSmartHome = lazy(() => import("./smart-home/ODSSmartHome"));
const ODSWifi = lazy(() => import("./wifi/ODSWifi"));
const ODSWifiConnected = lazy(
  () => import("./wifi-connected/ODSWifiConnected")
);
const ODSWifiConnectionError = lazy(
  () => import("./wifi-connection-error/ODSWifiConnectionError")
);
const ODSWifiNoWiredInternet = lazy(
  () => import("./wifi-no-wired-internet/ODSWifiNoWiredInternet")
);
const ODSWifiPreferred = lazy(
  () => import("./wifi-preferred/ODSWifiPreferred")
);
const ODSWifiReduced = lazy(() => import("./wifi-reduced/ODSWifiReduced"));
const ODSWifiSlow = lazy(() => import("./wifi-slow/ODSWifiSlow"));
const ODSWifiUnknown = lazy(() => import("./wifi-unknown/ODSWifiUnknown"));
const ODSActionCollapseDown = lazy(
  () => import("./action-collapse-down/ODSActionCollapseDown")
);
const ODSCircleArrowUp = lazy(
  () => import("./circle-arrow-up/ODSCircleArrowUp")
);
const ODSCollapseDown = lazy(() => import("./collapse-down/ODSCollapseDown"));
const ODSCollapseUp = lazy(() => import("./collapse-up/ODSCollapseUp"));
const ODSDoubleLeft = lazy(() => import("./double-left/ODSDoubleLeft"));
const ODSDoubleRight = lazy(() => import("./double-right/ODSDoubleRight"));
const ODSLeftCondensed = lazy(
  () => import("./left-condensed/ODSLeftCondensed")
);
const ODSLeftExtended = lazy(() => import("./left-extended/ODSLeftExtended"));
const ODSLocation = lazy(() => import("./location/ODSLocation"));
const ODSMap = lazy(() => import("./map/ODSMap"));
const ODSMyLocation = lazy(() => import("./my-location/ODSMyLocation"));
const ODSNavigationExternalLink = lazy(
  () => import("./navigation-external-link/ODSNavigationExternalLink")
);
const ODSNavigationLeft = lazy(
  () => import("./navigation-left/ODSNavigationLeft")
);
const ODSNavigationRight = lazy(
  () => import("./navigation-right/ODSNavigationRight")
);
const ODSNavigationStart = lazy(
  () => import("./navigation-start/ODSNavigationStart")
);
const ODSRightCondensed = lazy(
  () => import("./right-condensed/ODSRightCondensed")
);
const ODSRightExtended = lazy(
  () => import("./right-extended/ODSRightExtended")
);
const ODSTopUp = lazy(() => import("./top-up/ODSTopUp"));
const ODSOrderStatus = lazy(() => import("./order-status/ODSOrderStatus"));
const ODSProcessing = lazy(() => import("./processing/ODSProcessing"));
const ODSSepaTransaction = lazy(
  () => import("./sepa-transaction/ODSSepaTransaction")
);
const ODSDevicesService = lazy(
  () => import("./devices-service/ODSDevicesService")
);
const ODSMaintenance = lazy(() => import("./maintenance/ODSMaintenance"));
const ODSOneTimePassword = lazy(
  () => import("./one-time-password/ODSOneTimePassword")
);
const ODSOperatingManual = lazy(
  () => import("./operating-manual/ODSOperatingManual")
);
const ODSServiceButton = lazy(
  () => import("./service-button/ODSServiceButton")
);
const ODSServices = lazy(() => import("./services/ODSServices"));
const ODSSettings = lazy(() => import("./settings/ODSSettings"));
const ODSSupport = lazy(() => import("./support/ODSSupport"));
const ODSVpn = lazy(() => import("./vpn/ODSVpn"));
const ODSTProduct7 = lazy(() => import("./t-product-7/ODSTProduct7"));
const ODSMagentaAi = lazy(() => import("./magenta-ai/ODSMagentaAi"));
const ODSMagentaCloud = lazy(() => import("./magenta-cloud/ODSMagentaCloud"));
const ODSMagentaOne = lazy(() => import("./magenta-one/ODSMagentaOne"));
const ODSMagentaTv = lazy(() => import("./magenta-tv/ODSMagentaTv"));
const ODSMeasureInternetSpeed = lazy(
  () => import("./measure-internet-speed/ODSMeasureInternetSpeed")
);
const ODSPhoneWithLogo = lazy(
  () => import("./phone-with-logo/ODSPhoneWithLogo")
);
const ODSTelekomPlan = lazy(() => import("./telekom-plan/ODSTelekomPlan"));
const ODSTelekomShopB = lazy(() => import("./telekom-shop-b/ODSTelekomShopB"));
const ODSUnlimited = lazy(() => import("./unlimited/ODSUnlimited"));
const ODSUsage = lazy(() => import("./usage/ODSUsage"));
const ODSVoice = lazy(() => import("./voice/ODSVoice"));
const ODSAdmin = lazy(() => import("./admin/ODSAdmin"));
const ODSAnalytics = lazy(() => import("./analytics/ODSAnalytics"));
const ODSAttachment = lazy(() => import("./attachment/ODSAttachment"));
const ODSAudioFile = lazy(() => import("./audio-file/ODSAudioFile"));
const ODSBilling = lazy(() => import("./billing/ODSBilling"));
const ODSBoy = lazy(() => import("./boy/ODSBoy"));
const ODSBusinessUsers = lazy(
  () => import("./business-users/ODSBusinessUsers")
);
const ODSCommunities = lazy(() => import("./communities/ODSCommunities"));
const ODSContacts = lazy(() => import("./contacts/ODSContacts"));
const ODSContracts = lazy(() => import("./contracts/ODSContracts"));
const ODSContractsFromCloud = lazy(
  () => import("./contracts-from-cloud/ODSContractsFromCloud")
);
const ODSCsv = lazy(() => import("./csv/ODSCsv"));
const ODSDraftFile = lazy(() => import("./draft-file/ODSDraftFile"));
const ODSFamilies = lazy(() => import("./families/ODSFamilies"));
const ODSFamily = lazy(() => import("./family/ODSFamily"));
const ODSFile = lazy(() => import("./file/ODSFile"));
const ODSFileCollection = lazy(
  () => import("./file-collection/ODSFileCollection")
);
const ODSGirl = lazy(() => import("./girl/ODSGirl"));
const ODSHandshake = lazy(() => import("./handshake/ODSHandshake"));
const ODSHtmlFile = lazy(() => import("./html-file/ODSHtmlFile"));
const ODSIdCard = lazy(() => import("./id-card/ODSIdCard"));
const ODSImageFile = lazy(() => import("./image-file/ODSImageFile"));
const ODSLogin = lazy(() => import("./login/ODSLogin"));
const ODSMan = lazy(() => import("./man/ODSMan"));
const ODSManual = lazy(() => import("./manual/ODSManual"));
const ODSPdfFile = lazy(() => import("./pdf-file/ODSPdfFile"));
const ODSSwitchUsers = lazy(() => import("./switch-users/ODSSwitchUsers"));
const ODSUser = lazy(() => import("./user/ODSUser"));
const ODSWoman = lazy(() => import("./woman/ODSWoman"));
const ODSWeather1 = lazy(() => import("./weather-1/ODSWeather1"));
const ODSWeather2 = lazy(() => import("./weather-2/ODSWeather2"));
const ODSWeather3 = lazy(() => import("./weather-3/ODSWeather3"));
const ODSWeather4 = lazy(() => import("./weather-4/ODSWeather4"));
const ODSWeather5 = lazy(() => import("./weather-5/ODSWeather5"));
const ODSWeather6 = lazy(() => import("./weather-6/ODSWeather6"));
const ODSWeather7 = lazy(() => import("./weather-7/ODSWeather7"));
const ODSWeather8 = lazy(() => import("./weather-8/ODSWeather8"));
const ODSWeather9 = lazy(() => import("./weather-9/ODSWeather9"));
const ODSWeather10 = lazy(() => import("./weather-10/ODSWeather10"));
const ODSWeather11 = lazy(() => import("./weather-11/ODSWeather11"));
const ODSWeather12 = lazy(() => import("./weather-12/ODSWeather12"));
const ODSWeather13 = lazy(() => import("./weather-13/ODSWeather13"));
const ODSWeather14 = lazy(() => import("./weather-14/ODSWeather14"));
const ODSWeather15 = lazy(() => import("./weather-15/ODSWeather15"));
const ODSWeather16 = lazy(() => import("./weather-16/ODSWeather16"));
const ODSWeather17 = lazy(() => import("./weather-17/ODSWeather17"));
const ODSWeather18 = lazy(() => import("./weather-18/ODSWeather18"));
const ODSWeather19 = lazy(() => import("./weather-19/ODSWeather19"));
const ODSWeather20 = lazy(() => import("./weather-20/ODSWeather20"));
const ODSWeather21 = lazy(() => import("./weather-21/ODSWeather21"));
const ODSWeather22 = lazy(() => import("./weather-22/ODSWeather22"));

type IconComponents = Record<string, React.ComponentType<ODSIconProps>>;

const iconComponents: IconComponents = {
  add: ODSAdd,
  "add-card": ODSAddCard,
  arrange: ODSArrange,
  "arrow-down": ODSArrowDown,
  "arrow-left": ODSArrowLeft,
  "arrow-right": ODSArrowRight,
  "arrow-u-turn-backwards": ODSArrowUTurnBackwards,
  "arrow-u-turn-forwards": ODSArrowUTurnForwards,
  "arrow-up": ODSArrowUp,
  "auto-login": ODSAutoLogin,
  backspace: ODSBackspace,
  backward: ODSBackward,
  cast: ODSCast,
  changelog: ODSChangelog,
  checkmark: ODSCheckmark,
  "circle-add": ODSCircleAdd,
  "circle-close": ODSCircleClose,
  "circle-fast-forward": ODSCircleFastForward,
  "circle-minus": ODSCircleMinus,
  "circle-pause": ODSCirclePause,
  "circle-play": ODSCirclePlay,
  close: ODSClose,
  compare: ODSCompare,
  "copy-paste": ODSCopyPaste,
  "cut-paste": ODSCutPaste,
  delete: ODSDelete,
  "disabled-microphone": ODSDisabledMicrophone,
  "dot-grid": ODSDotGrid,
  download: ODSDownload,
  "download-from-cloud": ODSDownloadFromCloud,
  "drag-and-drop": ODSDragAndDrop,
  edit: ODSEdit,
  export: ODSExport,
  "fast-forward": ODSFastForward,
  filter: ODSFilter,
  "filter-2": ODSFilter2,
  forward: ODSForward,
  group: ODSGroup,
  import: ODSImport,
  install: ODSInstall,
  launch: ODSLaunch,
  "light-dark-mode": ODSLightDarkMode,
  link: ODSLink,
  logout: ODSLogout,
  loop: ODSLoop,
  "magic-wand": ODSMagicWand,
  "maximize-screen": ODSMaximizeScreen,
  menu: ODSMenu,
  microphone: ODSMicrophone,
  "minimize-screen": ODSMinimizeScreen,
  minus: ODSMinus,
  more: ODSMore,
  move: ODSMove,
  mute: ODSMute,
  notification: ODSNotification,
  pause: ODSPause,
  pin: ODSPin,
  play: ODSPlay,
  "pop-up-window": ODSPopUpWindow,
  power: ODSPower,
  previous: ODSPrevious,
  print: ODSPrint,
  publish: ODSPublish,
  record: ODSRecord,
  refresh: ODSRefresh,
  "reply-all": ODSReplyAll,
  "reply-forward": ODSReplyForward,
  restart: ODSRestart,
  return: ODSReturn,
  search: ODSSearch,
  share: ODSShare,
  "shopping-cart": ODSShoppingCart,
  shuffle: ODSShuffle,
  sort: ODSSort,
  "sound-on": ODSSoundOn,
  star: ODSStar,
  success: ODSSuccess,
  "thumbs-down": ODSThumbsDown,
  "thumbs-up": ODSThumbsUp,
  "tiles-add": ODSTilesAdd,
  ungroup: ODSUngroup,
  upload: ODSUpload,
  "upload-to-cloud": ODSUploadToCloud,
  "visibility-off": ODSVisibilityOff,
  "visibility-on": ODSVisibilityOn,
  "volume-down": ODSVolumeDown,
  "volume-up": ODSVolumeUp,
  "zoom-in": ODSZoomIn,
  "zoom-out": ODSZoomOut,
  "antivirus-protection": ODSAntivirusProtection,
  compliance: ODSCompliance,
  "cyber-security": ODSCyberSecurity,
  error: ODSError,
  help: ODSHelp,
  "high-priority": ODSHighPriority,
  "imprint-dataprivacy": ODSImprintDataprivacy,
  information: ODSInformation,
  legal: ODSLegal,
  "network-disrupted": ODSNetworkDisrupted,
  "password-breaking": ODSPasswordBreaking,
  security: ODSSecurity,
  "traffic-disruption": ODSTrafficDisruption,
  unknown: ODSUnknown,
  warning: ODSWarning,
  "add-phone": ODSAddPhone,
  blog: ODSBlog,
  call: ODSCall,
  "call-incoming": ODSCallIncoming,
  "call-outgoing": ODSCallOutgoing,
  chat: ODSChat,
  "chat-badge": ODSChatBadge,
  "chat-text": ODSChatText,
  email: ODSEmail,
  "end-call": ODSEndCall,
  feedback: ODSFeedback,
  "flight-mode": ODSFlightMode,
  "happy-person": ODSHappyPerson,
  inbox: ODSInbox,
  "loyalty-earned": ODSLoyaltyEarned,
  "loyalty-lost": ODSLoyaltyLost,
  "mail-opened": ODSMailOpened,
  message: ODSMessage,
  "message-incoming": ODSMessageIncoming,
  "message-outgoing": ODSMessageOutgoing,
  mms: ODSMms,
  "mobile-phone-number": ODSMobilePhoneNumber,
  "mobile-signal": ODSMobileSignal,
  "new-email": ODSNewEmail,
  outbox: ODSOutbox,
  recipient: ODSRecipient,
  "save-emails-to-drafts": ODSSaveEmailsToDrafts,
  sms: ODSSms,
  spam: ODSSpam,
  "voice-messages": ODSVoiceMessages,
  achievement: ODSAchievement,
  android: ODSAndroid,
  api: ODSApi,
  apple: ODSApple,
  applications: ODSApplications,
  at: ODSAt,
  "available-keychain": ODSAvailableKeychain,
  bank: ODSBank,
  battery: ODSBattery,
  "battery-charge-optimize": ODSBatteryChargeOptimize,
  biometric: ODSBiometric,
  birthday: ODSBirthday,
  bookmark: ODSBookmark,
  calendar: ODSCalendar,
  clipboard: ODSClipboard,
  clock: ODSClock,
  cloud: ODSCloud,
  "cloud-security": ODSCloudSecurity,
  "code-scanner": ODSCodeScanner,
  "color-selection": ODSColorSelection,
  company: ODSCompany,
  country: ODSCountry,
  cpu: ODSCpu,
  "credit-card": ODSCreditCard,
  "data-visualisation": ODSDataVisualisation,
  "digital-banking": ODSDigitalBanking,
  "digital-media": ODSDigitalMedia,
  discount: ODSDiscount,
  "discount-3": ODSDiscount3,
  "e-sim": ODSESim,
  eu: ODSEu,
  "face-mask": ODSFaceMask,
  features: ODSFeatures,
  "flexible-tariffs": ODSFlexibleTariffs,
  folder: ODSFolder,
  food: ODSFood,
  "gender-diverse": ODSGenderDiverse,
  "gender-female": ODSGenderFemale,
  "gender-male": ODSGenderMale,
  "gender-neutral": ODSGenderNeutral,
  "half-rating": ODSHalfRating,
  heart: ODSHeart,
  height: ODSHeight,
  history: ODSHistory,
  "hour-glass": ODSHourGlass,
  id: ODSId,
  "in-stock": ODSInStock,
  international: ODSInternational,
  "international-sms": ODSInternationalSms,
  key: ODSKey,
  language: ODSLanguage,
  lightbulb: ODSLightbulb,
  lock: ODSLock,
  loyalty: ODSLoyalty,
  "media-folder": ODSMediaFolder,
  "microphone-external": ODSMicrophoneExternal,
  "multi-sim": ODSMultiSim,
  music: ODSMusic,
  news: ODSNews,
  "out-of-stock": ODSOutOfStock,
  package: ODSPackage,
  "package-delivery": ODSPackageDelivery,
  "person-walking": ODSPersonWalking,
  "prepaid-activate": ODSPrepaidActivate,
  "price-tag": ODSPriceTag,
  route: ODSRoute,
  rss: ODSRss,
  sale: ODSSale,
  shop: ODSShop,
  signal: ODSSignal,
  "sim-card": ODSSimCard,
  "sim-inactive": ODSSimInactive,
  smile: ODSSmile,
  "sort-indicator-down": ODSSortIndicatorDown,
  "sort-indicator-up": ODSSortIndicatorUp,
  "status-inactive": ODSStatusInactive,
  stopwatch: ODSStopwatch,
  "support-chat": ODSSupportChat,
  sustainable: ODSSustainable,
  tariffs: ODSTariffs,
  temperature: ODSTemperature,
  threats: ODSThreats,
  "to-do-list": ODSToDoList,
  tools: ODSTools,
  transport: ODSTransport,
  "two-factor-authentification": ODSTwoFactorAuthentification,
  unlock: ODSUnlock,
  voucher: ODSVoucher,
  waiting: ODSWaiting,
  wallet: ODSWallet,
  "add-device": ODSAddDevice,
  "camera-off": ODSCameraOff,
  "change-camera": ODSChangeCamera,
  computer: ODSComputer,
  "controller-device": ODSControllerDevice,
  "device-ethernet": ODSDeviceEthernet,
  "device-tv": ODSDeviceTv,
  dongle: ODSDongle,
  fax: ODSFax,
  "fixed-line-services": ODSFixedLineServices,
  "fixed-line-services-3": ODSFixedLineServices3,
  "game-controller": ODSGameController,
  "media-receiver": ODSMediaReceiver,
  "mesh-wifi": ODSMeshWifi,
  "mobile-data": ODSMobileData,
  "mobile-devices": ODSMobileDevices,
  "mobile-equipment": ODSMobileEquipment,
  "mobile-phone-insurance": ODSMobilePhoneInsurance,
  "mobile-services": ODSMobileServices,
  phone: ODSPhone,
  "phone-with-mobile-plan": ODSPhoneWithMobilePlan,
  "phone-without-mobile-plan": ODSPhoneWithoutMobilePlan,
  "photo-camera": ODSPhotoCamera,
  "remote-controller": ODSRemoteController,
  "replacement-mobile-phone": ODSReplacementMobilePhone,
  "rotate-locked": ODSRotateLocked,
  "rotate-open": ODSRotateOpen,
  router: ODSRouter,
  "screen-rotate": ODSScreenRotate,
  server: ODSServer,
  "smart-speaker": ODSSmartSpeaker,
  tablet: ODSTablet,
  "tv-and-mobile": ODSTvAndMobile,
  "video-camera": ODSVideoCamera,
  watch: ODSWatch,
  "wifi-device": ODSWifiDevice,
  home: ODSHome,
  "internet-home": ODSInternetHome,
  iot: ODSIot,
  "light-bulb": ODSLightBulb,
  "network-secure": ODSNetworkSecure,
  "power-socket": ODSPowerSocket,
  "power-socket-3": ODSPowerSocket3,
  "router-disconnected": ODSRouterDisconnected,
  "smart-home": ODSSmartHome,
  wifi: ODSWifi,
  "wifi-connected": ODSWifiConnected,
  "wifi-connection-error": ODSWifiConnectionError,
  "wifi-no-wired-internet": ODSWifiNoWiredInternet,
  "wifi-preferred": ODSWifiPreferred,
  "wifi-reduced": ODSWifiReduced,
  "wifi-slow": ODSWifiSlow,
  "wifi-unknown": ODSWifiUnknown,
  "action-collapse-down": ODSActionCollapseDown,
  "circle-arrow-up": ODSCircleArrowUp,
  "collapse-down": ODSCollapseDown,
  "collapse-up": ODSCollapseUp,
  "double-left": ODSDoubleLeft,
  "double-right": ODSDoubleRight,
  "left-condensed": ODSLeftCondensed,
  "left-extended": ODSLeftExtended,
  location: ODSLocation,
  map: ODSMap,
  "my-location": ODSMyLocation,
  "navigation-external-link": ODSNavigationExternalLink,
  "navigation-left": ODSNavigationLeft,
  "navigation-right": ODSNavigationRight,
  "navigation-start": ODSNavigationStart,
  "right-condensed": ODSRightCondensed,
  "right-extended": ODSRightExtended,
  "top-up": ODSTopUp,
  "order-status": ODSOrderStatus,
  processing: ODSProcessing,
  "sepa-transaction": ODSSepaTransaction,
  "devices-service": ODSDevicesService,
  maintenance: ODSMaintenance,
  "one-time-password": ODSOneTimePassword,
  "operating-manual": ODSOperatingManual,
  "service-button": ODSServiceButton,
  services: ODSServices,
  settings: ODSSettings,
  support: ODSSupport,
  vpn: ODSVpn,
  "t-product-7": ODSTProduct7,
  "magenta-ai": ODSMagentaAi,
  "magenta-cloud": ODSMagentaCloud,
  "magenta-one": ODSMagentaOne,
  "magenta-tv": ODSMagentaTv,
  "measure-internet-speed": ODSMeasureInternetSpeed,
  "phone-with-logo": ODSPhoneWithLogo,
  "telekom-plan": ODSTelekomPlan,
  "telekom-shop-b": ODSTelekomShopB,
  unlimited: ODSUnlimited,
  usage: ODSUsage,
  voice: ODSVoice,
  admin: ODSAdmin,
  analytics: ODSAnalytics,
  attachment: ODSAttachment,
  "audio-file": ODSAudioFile,
  billing: ODSBilling,
  boy: ODSBoy,
  "business-users": ODSBusinessUsers,
  communities: ODSCommunities,
  contacts: ODSContacts,
  contracts: ODSContracts,
  "contracts-from-cloud": ODSContractsFromCloud,
  csv: ODSCsv,
  "draft-file": ODSDraftFile,
  families: ODSFamilies,
  family: ODSFamily,
  file: ODSFile,
  "file-collection": ODSFileCollection,
  girl: ODSGirl,
  handshake: ODSHandshake,
  "html-file": ODSHtmlFile,
  "id-card": ODSIdCard,
  "image-file": ODSImageFile,
  login: ODSLogin,
  man: ODSMan,
  manual: ODSManual,
  "pdf-file": ODSPdfFile,
  "switch-users": ODSSwitchUsers,
  user: ODSUser,
  woman: ODSWoman,
  "weather-1": ODSWeather1,
  "weather-2": ODSWeather2,
  "weather-3": ODSWeather3,
  "weather-4": ODSWeather4,
  "weather-5": ODSWeather5,
  "weather-6": ODSWeather6,
  "weather-7": ODSWeather7,
  "weather-8": ODSWeather8,
  "weather-9": ODSWeather9,
  "weather-10": ODSWeather10,
  "weather-11": ODSWeather11,
  "weather-12": ODSWeather12,
  "weather-13": ODSWeather13,
  "weather-14": ODSWeather14,
  "weather-15": ODSWeather15,
  "weather-16": ODSWeather16,
  "weather-17": ODSWeather17,
  "weather-18": ODSWeather18,
  "weather-19": ODSWeather19,
  "weather-20": ODSWeather20,
  "weather-21": ODSWeather21,
  "weather-22": ODSWeather22,
};

const ODSIcon = ({ name, ...props }: ODSIconProps) => {
  let isSelected;
  let isSmall = false;
  let iconName;
  if (name?.includes("-type-bold")) {
    isSelected = true;
    iconName = name.replace("-type-bold", "");
  } else {
    iconName = name ? name.replace("-type-standard", "") : undefined;
  }
  if (name?.includes("-size-small")) {
    isSmall = true;
    iconName = iconName?.replace("-size-small", "");
  }
  if (iconName !== undefined && iconName.length > 0) {
    const SelectedIcon = iconComponents[iconName];
    if (!SelectedIcon) {
      console.error(`Icon with name "${iconName}" not found.`);
      return null;
    }
    const size = isSmall ? (props?.size ?? 24) : (props?.size ?? 16);
    const style = { width: size, height: size };
    return (
      <Suspense
        fallback={<div className="ODSIcon-placeholder" style={style}></div>}
      >
        <SelectedIcon selected={isSelected} small={isSmall} {...props} />
      </Suspense>
    );
  }
  return null;
};

export default ODSIcon;
